class EluxaAccordion extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      const head = event.target.closest('[data-eluxa-acc-toggle]');
      if (!head) return;

      const item = head.closest('.eluxa-acc-item');
      if (!item) return;

      const isOpen = item.classList.contains('open');

      this.querySelectorAll('.eluxa-acc-item.open').forEach((el) => {
        el.classList.remove('open');
        const body = el.querySelector('.eluxa-acc-body');
        if (body) body.style.maxHeight = '';
      });

      if (!isOpen) {
        item.classList.add('open');
        const body = item.querySelector('.eluxa-acc-body');
        if (body) body.style.maxHeight = `${body.scrollHeight}px`;
      }
    });

    const openBody = this.querySelector('.eluxa-acc-item.open .eluxa-acc-body');
    if (openBody) openBody.style.maxHeight = `${openBody.scrollHeight}px`;
  }
}

customElements.define('eluxa-accordion', EluxaAccordion);
